var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[
    'ml-icon-button',
    `ml-icon-button-${_vm.variant}`,
    { 'is-disabled': _vm.disabled || _vm.spinning }
  ],attrs:{"disabled":_vm.disabled || _vm.spinning},on:{"click":function($event){$event.preventDefault();return _vm.clicked.apply(null, arguments)}}},[(_vm.spinning)?_c('memlist-spinner',{staticClass:"mr-2",staticStyle:{"min-height":"24px"},attrs:{"size":"sm"}}):_c('span',{staticClass:"svg-icon svg-icon-sm icon-inherit mr-2"},[(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e(),(_vm.svg)?_c('inline-svg',{attrs:{"src":_vm.svg,"fill":"currentColor"}}):_vm._e()],1),_c('span',[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }